// Gatsby requirements
import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import { storyblokEditable } from "gatsby-source-storyblok";

// Styles
import * as CSS from './Topics.module.scss'


const Topics = ({ data }) => {

    const query = useStaticQuery(graphql`
        query {
            categoryTags: allStoryblokDatasourceEntry(filter: {data_source: {eq: "blog-tags"}}) {
                nodes {
                    name
                    value
                }
            }
            patientResourceTags: allStoryblokDatasourceEntry(filter: {data_source: {eq: "patient-resource-tags"}}) {
                nodes {
                    name
                    value
                }
            }
        }
    `)

    return (
        <section className={CSS.section} {...storyblokEditable(data)}>
            <h2>{data.title}</h2>
            <ul>
                {!data?.showPatientResourceTags && query.categoryTags.nodes.map((loop) => (
                    <li><Link to={`/learn/categories/${loop.value}/`}>{loop.name}</Link></li>
                ))}

                {data?.showPatientResourceTags && query.patientResourceTags.nodes.map((loop) => (
                    <li><Link to={`/patient-resources/categories/${loop.value}/`}>{loop.name}</Link></li>
                ))}
            </ul>
        </section>
    )
}

export default Topics